// extracted by mini-css-extract-plugin
module.exports = {"CommentsButton":"jb_a bhv_vr bhv_iv bhv_wf bhv_i bhv_j bhv_q bhv_un bhv_en bhv_ri bhv_rj bhv_cx","CommentsButton__icon":"jb_b bhv_re"};